<template>

    <Toast/>

    <MenuSiModuleMain/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div v-if="this.systemConfig.siUpdateInProgress === 'Y'"
                         class="flex align-items-start p-4 bg-pink-100 border-round border-1 border-pink-300">
                        <i class="pi pi-exclamation-triangle text-pink-900 text-2xl mr-3"></i>
                        <div class="mr-3">
                            <div class="text-pink-900 font-medium text-xl mb-3 line-height-1">Stock data update in
                                progress, please check back later if you need to access this information. The remainder
                                of the software functionality is still operational.
                            </div>
                        </div>
                    </div>

                    <h2>Hello {{ this.profile.firstName }}</h2>

                    <div class="grid">

                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li v-show="this.profile.rights != 'C'">
                                <a @click="callColumnDefinitions" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Column Definitions</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <div class="grid">
                        <div class="col-12">

                            <div v-if="this.selectedStandardFilter === 'DOW30'" class="card">
                                <Fieldset legend="DOW 30 is a list of 30 US stocks that make up the ..."
                                          :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        DOW 30 is a list of 30 US stocks that make up the DOW 30 index of companies.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest number of years of consecutive
                                        dividend increases to the lowest. The SI Criteria score is data-driven
                                        and does not involve any human intervention, you are still responsible for
                                        applying Rules 1 to 4 and 12 before making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'TSX60'" class="card">
                                <Fieldset
                                    legend="TSX 60 is a list of the S&P/TSX 60 Index, a stock market list of 60 large ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        TSX 60 is a list of the S&P/TSX 60 Index, a stock market list of 60 large
                                        companies trading on the Toronto Stock Exchange.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest number of years of consecutive
                                        dividend increases to the lowest. The SI Criteria score is data-driven
                                        and does not involve any human intervention, you are still responsible for
                                        applying Rules 1 to 4 and 12 before making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'TR'" class="card">
                                <Fieldset
                                    legend="Top Ranked Stocks are dividend-paying stocks that are of the highest quality and ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Top Ranked Stocks are dividend-paying stocks that are of the highest quality and
                                        undervalued (based on 20-year data). These stocks have met all
                                        10 quantitative rules of Simply Investing (SI Criteria). In the long-term these
                                        stocks have the highest potential for capital appreciation and dividend
                                        growth.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest number of years of consecutive
                                        dividend increases to the lowest. The SI Criteria score is data-driven
                                        and does not involve any human intervention, you are still responsible for
                                        applying Rules 1 to 4 and 12 before making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'RU'" class="card">
                                <Fieldset
                                    legend="Runners-Up are dividend-paying stocks that have met 9 out of 10 quantitative rules of ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Runners-Up are dividend-paying stocks that have met 9 out of 10 quantitative
                                        rules of Simply Investing (SI Criteria), have not had a recent dividend
                                        cut, and are undervalued (based on 20-year data). In the long-term these stocks
                                        may also have the potential for capital appreciation and dividend
                                        growth.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest number of years of consecutive
                                        dividend increases to the lowest. The SI Criteria score is data-driven
                                        and does not involve any human intervention, you are still responsible for
                                        applying Rules 1 to 4 and 12, and make sure you are comfortable with the
                                        1 failed SI Criteria (failed values are highlighted).
                                        growth.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'DSU'" class="card">
                                <Fieldset
                                    legend="Dividend Stocks Undervalued are dividend-paying stocks that are trading at historically low ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Dividend Stocks Undervalued are dividend-paying stocks that are trading at
                                        historically low prices (undervalued), because their current dividend
                                        yield is higher than their average dividend yield and can be considered for
                                        purchase: start with those which have the highest SI Criteria grade out
                                        of 10.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest SI Criteria to the lowest. The
                                        SI Criteria score is data-driven and does not involve any human
                                        intervention, you are still responsible for applying Rules 1 to 4 and 12 before
                                        making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'DSO'" class="card">
                                <Fieldset
                                    legend="Dividend Stocks Overvalued are dividend-paying stocks that are trading at historically high ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Dividend Stocks Overvalued are dividend-paying stocks that are trading at
                                        historically high prices (overvalued), because their current dividend
                                        yield is less than (or equal to) their average dividend yield and should not be
                                        considered for purchase at this time.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest SI Criteria to the lowest. If
                                        you already own these stocks, they can be considered for sale after a
                                        complete analysis.
                                    </p>
                                </Fieldset>
                            </div>


                            <div v-else-if="this.selectedStandardFilter === 'DSD'" class="card">
                                <Fieldset
                                    legend="Dividend Stocks Deep Valued are dividend-paying stocks that are trading at historically very low ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Dividend Stocks Deep Valued are dividend-paying stocks that are trading at
                                        historically very low prices (deep valued), because the difference
                                        between their current dividend yield and average dividend yield is equal to or
                                        greater than 200%.
                                        <br/><br/>
                                        By default, stocks are ordered from highest SI Criteria to the lowest. The SI
                                        Criteria score is data-driven and does not involve any human
                                        intervention, you are still responsible for applying Rules 1 to 4 and 12 before
                                        making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>


                            <div v-else-if="this.selectedStandardFilter === 'NDSU'" class="card">
                                <Fieldset
                                    legend="Non Dividend Stocks Undervalued are non-dividend stocks that are trading at historically low ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Non-Dividend Stocks Undervalued are non-dividend stocks that are trading at
                                        historically low prices (undervalued), because their current P/E
                                        Ratio is less than their average P/E Ratio.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest SI Criteria to the lowest. The
                                        SI Criteria score is data-driven and does not involve any human
                                        intervention, you are still responsible for applying Rules 1 to 4 and 12 before
                                        making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>


                            <div v-else-if="this.selectedStandardFilter === 'NDSO'" class="card">
                                <Fieldset
                                    legend="Non-Dividend Stocks Overvalued are non-dividend stocks that are trading at historically high ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Non-Dividend Stocks Overvalued are non-dividend stocks that are trading at
                                        historically high prices (overvalued), because their current P/E Ratio
                                        is greater than or equal to their average P/E Ratio.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest SI Criteria to the lowest. The
                                        SI Criteria score is data-driven and does not involve any human
                                        intervention, you are still responsible for applying Rules 1 to 4 and 12 before
                                        making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                            <div v-else-if="this.selectedStandardFilter === 'NDSD'" class="card">
                                <Fieldset
                                    legend="Non-Dividend Stocks Deep Valued are non-dividend stocks that are trading at historically very low ..."
                                    :toggleable="true" :collapsed="true">
                                    <p class="line-height-3 m-0">
                                        Non-Dividend Stocks Deep Valued are non-dividend stocks that are trading at
                                        historically very low prices (deep valued), because the difference
                                        between their current P/E Ratio and their average P/E Ratio is less than or
                                        equal to -90%.
                                        <br/><br/>
                                        By default, stocks are ordered from the highest SI Criteria to the lowest. The
                                        SI Criteria score is data-driven and does not involve any human
                                        intervention, you are still responsible for applying Rules 1 to 4 and 12 before
                                        making any investing decisions.
                                    </p>
                                </Fieldset>
                            </div>

                        </div>
                    </div>

                    <div class="grid" v-show="this.loading === true">
                        <ProgressSpinner v-if="loading" style="width: 16px; height: 16px" strokeWidth="6"
                                         fill="transparent" animationDuration=".5s"
                                         aria-label="Custom ProgressSpinner"/>
                    </div>

                    <div class="grid" v-show="this.loading === false">
                        &nbsp;
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <DataTable
                                    :value="stockData"
                                    lazy
                                    paginator
                                    :rows="lazyParams.rows"
                                    :first="lazyParams.first"
                                    :totalRecords="totalRecords"
                                    :loading="loading"
                                    :sortField="lazyParams.sortField"
                                    :sortOrder="lazyParams.sortOrder"
                                    :filterConstraints="lazyParams.filters"
                                    :sortMode="'single'"
                                    :rowHover="true"
                                    :striped-rows="true"
                                    :reorderableColumns="true"
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    :scrollable="true" scrollDirection="both"
                                    scrollHeight="750px"
                                    :globalFilterFields="['id', 'uniqueId', 'clientName', 'paid', 'description', 'amount']"
                                    @page="onPage"
                                    @sort="onSort"
                                    @filter="onFilter">

                                    <template #header>

                                        <div class="col-12">
                                            <div class="card p-fluid">
                                                <div class="grid">

                                                    <div class="col-12 lg:col-3 p-3">
                                                        <Dropdown v-model="selectedStandardFilter"
                                                                  :options="standardFilters"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Filter"
                                                                  @change="onFilterChange"/>
                                                    </div>

                                                    <div v-show="this.profile.rights === 'C'"
                                                         class="col-12 lg:col-5 p-3">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"/>
                                                            <InputText v-model="filters['global'].value"
                                                                       placeholder="Keyword Search on Stock Symbol (Please press enter to search)"
                                                                       style="width: 100%"
                                                                       @keyup.enter="onSearch"/>

                                                        </span>
                                                    </div>

                                                    <div v-show="this.profile.rights === 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Button type="button" icon="pi pi-filter-slash"
                                                                label="Search/Compare"
                                                                class="p-button-outlined p-ml-2"
                                                                @click="callBasicSearch()"/>
                                                    </div>

                                                    <div v-show="this.profile.rights === 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Button type="button" icon="pi pi-replay"
                                                                label="Restore to Original View"
                                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedExchange" :options="exchanges"
                                                                  :disabled="(this.selectedStandardFilter === 'DOW30') || (this.selectedStandardFilter === 'TSX60')"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select an Exchange"
                                                                  @change="onExchangeChange"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedTimePeriod" :options="timePeriods"
                                                                  :disabled="(this.selectedStandardFilter === 'DOW30') || (this.selectedStandardFilter === 'TSX60')"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Time Period"
                                                                  @change="onTimePeriodChange"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-3 p-3">
                                                        <MultiSelect v-model="selectedColumns"
                                                                     :options="columnConfig"
                                                                     optionLabel="header"
                                                                     optionValue="field"
                                                                     @change="onToggleColumns"
                                                                     display="chip"
                                                                     placeholder="Select Columns"
                                                                     :filter="true"
                                                                     filterPlaceholder="Search columns..."
                                                                     :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedFormat" :options="formats"
                                                                  optionLabel="name"
                                                                  optionValue="code" placeholder="Select a Format"
                                                                  @change="onFormatChange"/>
                                                    </div>

                                                </div>


                                                <div class="grid">
                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-4 p-3">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"/>
                                                            <InputText v-model="filters['global'].value"
                                                                       placeholder="Keyword Search on Stock Symbol (Please press enter to search)"
                                                                       style="width: 100%"
                                                                       @keyup.enter="onSearch"/>

                                                        </span>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Button type="button" icon="pi pi-filter-slash"
                                                                label="Search/Compare"
                                                                class="p-button-outlined p-ml-2"
                                                                @click="callBasicSearch()"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedCustomFilter"
                                                                  :options="customFiltersActive"
                                                                  optionLabel="name" optionValue="id"
                                                                  placeholder="Select a Custom Filter"
                                                                  @change="onCustomFilterChange"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Button type="button" icon="pi pi-replay" label="Manage Filters"
                                                                class="p-button-outlined" @click="callManageFilters()"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Button type="button" icon="pi pi-replay"
                                                                label="Restore to Original View"
                                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </template>

                                    <template #empty>
                                        No stock data found.
                                    </template>

                                    <template #loading>
                                        Loading stock data. Please wait.
                                    </template>

                                    <Column v-for="column in filteredColumns" :key="column.field" :field="column.field"
                                            :sortable="column.sortable" :style="column.style"
                                            :frozen="column.frozen || false">

                                        <template #header>
                                            <span v-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))"
                                                  v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))"
                                                  v-tooltip="'[undervalued]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))" v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'pbRatioId102')"
                                                  v-tooltip="'[3 or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'peRatioId104')"
                                                  v-tooltip="'[25 or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'shareBuybackId122')"
                                                  v-tooltip="'[yes]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'afdPreviousId005')"
                                                  v-tooltip="'[0% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')"
                                                  v-tooltip="'[70% or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'payoutRatioId107')"
                                                  v-tooltip="'[75% or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear20Id097')"
                                                  v-tooltip="'[8 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear15Id096')"
                                                  v-tooltip="'[6 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear10Id095')"
                                                  v-tooltip="'[4 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear5Id094')"
                                                  v-tooltip="'[2 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else>
                                                {{ column.header }}
                                            </span>
                                        </template>

                                        <template #body="{ data }">

                                            <span v-if="column.field === 'codeId129'">
                                                <a href="javascript:void(0)" @click="onCompanyCodeClick(data)">
                                                    {{ data[column.field] }}
                                                </a>
                                            </span>

                                            <span v-else-if="column.field === 'sharePriceId123'">
                                                {{ formatAmount(data[column.field]) }}
                                            </span>

                                            <span v-else-if="column.field === 'currentDividendYieldId050'">
                                                {{ formatAmount(data[column.field]) }}%

                                                <span v-if="((data[column.field] > maxDividendYield) &&
                                                    ((this.selectedStandardFilter != 'DOW30') && (this.selectedStandardFilter != 'TSX60')))"
                                                      :class="'status-badge status-DT'"
                                                      @click="handleDividendTrapInfo(data)">DT
                                                </span>

                                            </span>

                                            <span v-else-if="((column.field === 'siCriteriaYear20Id128') ||
                                                (column.field === 'siCriteriaYear15Id127') ||
                                                (column.field === 'siCriteriaYear10Id126') ||
                                                (column.field === 'siCriteriaYear5Id125'))">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else-if="column.field === 'companyNameId046'">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))">

                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear20Id097')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 8">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear15Id096')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 6">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear10Id095')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 4">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear5Id094')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 2">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))">
                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                            <span v-else-if="(column.field === 'payoutRatioId107')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'afdPreviousId005')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] >= 0)">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else-if="(data[column.field] === -999999)">
                                                    non-dividend stock
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'shareBuybackId122')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                                <span v-else :class="'highlight'">No</span>
                                            </span>

                                            <span v-else-if="(column.field === 'peRatioId104')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                                <span v-else :class="'highlight'">Over-valued</span>
                                            </span>

                                            <span v-else-if="(column.field === 'pbRatioId102')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                                (column.field === 'yearsEpsIncreasesId048') ||
                                                (column.field === 'employeesId093') ||
                                                (column.field === 'epsIncreasesYear5Id094') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear20Id097'))">
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else>
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'sharePriceDateId124')">
                                                {{ data[column.field]?.split(' ')[0] }}
                                            </span>

                                            <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                                (column.field === 'companyAddressCountryId042') ||
                                                (column.field === 'companyAddressStateId043') ||
                                                (column.field === 'companyAddressId044') ||
                                                (column.field === 'companyDescriptionId045') ||
                                                (column.field === 'industryId081') ||
                                                (column.field === 'marketId089') ||
                                                (column.field === 'sectorId121') ||
                                                (column.field === 'websiteId136') ||
                                                (column.field === 'dividendCurrencyId062') ||
                                                (column.field === 'dividendFrequencyId063') ||
                                                (column.field === 'dividendPaymentDateId068') ||
                                                (column.field === 'dividendRecordDateId069') ||
                                                (column.field === 'exDividendDateId074') ||
                                                (column.field === 'fiscalYearendDateId075') ||
                                                (column.field === 'dividendPaidId070'))">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else>
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                                <span v-else>
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        </template>
                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h2>Hello {{ this.profile.firstName }}</h2>

                    <div class="grid">

                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callColumnDefinitions" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Column Definitions</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Dividend Trap</h3>

                    <span>
                        View the video below, to learn how to identify and avoid dividend traps.

                        <br/><br/>
                        You are on this page because you've clicked on the text "DT" within a cell in the stock tables.

                        <br/><br/>
                        "DT" represents a stock that might be a possible Dividend Trap, these types of stocks are to be
                        avoided.

                        <br/><br/>
                        <h4>What is a Dividend Trap?</h4>
                        A dividend trap is a too-good-to-be-true dividend yield (that's typically very high) that's
                        unsustainable. There is a high risk that the dividend will be reduced or eliminated.

                        <br/><br/>
                        <h4>How to Avoid a Dividend Trap?</h4>
                        As explained in the video above, the best way to avoid a dividend trap is to avoid investing in
                        a stock with a very high dividend yield.

                        <br/><br/>
                        <h4>How does the SI Platform Identify Possible Dividend Traps for US Stocks?</h4>
                        The SI Platform performs the following four actions:
                        <br/>
                        1. It will calculate the average current dividend yield of all Top Ranked and Runners-Up US
                        stocks
                        <br/>
                        2. It will then multiply the above value (from Step 1) by 2.5 times, the resulting value is
                        called the
                        "maximum dividend yield"
                        <br/>
                        3. Any stock that exceeds the "maximum dividend yield" will be indentified as a possible
                        "Dividend Trap"
                        <br/>
                        4. Any possible "Dividend Trap" will have it's current dividend yield displayed in bold, it's
                        cell will
                        be highlighted in orange, and the text "DT" will be displayed next to the current dividend yield
                        value

                        <br/><br/>
                        <h4>How does the SI Platform Identify Possible Dividend Traps for Canadian Stocks?</h4>
                        The SI Platform performs the following four actions:
                        <br/>
                        1. It will calculate the average current dividend yield of all Top Ranked and Runners-Up
                        Canadian stocks
                        <br/>
                        2. It will then multiply the above value (from Step 1) by 2.5 times, the resulting value is
                        called the
                        "maximum dividend yield"
                        <br/>
                        3. Any stock that exceeds the "maximum dividend yield" will be indentified as a possible
                        "Dividend Trap"
                        <br/>
                        4. Any possible "Dividend Trap" will have it's current dividend yield displayed in bold, it's
                        cell will
                        be highlighted in orange, and the text "DT" will be displayed next to the current dividend yield
                        value
                    </span>

                    <div class="col-12 md:col-6 lg:col-4">
                        <div class="p-2">
                            <div class="shadow-2 p-4 surface-card border-round">

                                <div style="padding:56.25% 0 0 0;position:relative;">
                                    <iframe src="https://www.youtube.com/embed/SsOno5z_hl0?si=2usedkTiFE9ngz7a"
                                            frameborder="0"
                                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                            style="position:absolute;top:0;left:0;width:100%;height:100%;"
                                            title="893379528-lesson1"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="col-12">
                        <div class="card">
                            <h3>Stock Data for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card">
                                    <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>
                                </div>
                            </div>


                            <h3>Key Information for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-4">
                                    <label for="codeId129" style="font-weight: bold;">Stock Symbol</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.codeId129 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="lastname2" style="font-weight: bold;">Currency</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendCurrencyId062 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="epsTtmId071" style="font-weight: bold;">EPS (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.epsTtmId071) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceId123" style="font-weight: bold;">Share Price</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.sharePriceId123 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="exchangeId073" style="font-weight: bold;">Exchange</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.exchangeId073 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="payoutRatioId107" style="font-weight: bold;">Payout Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.payoutRatioId107) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceDateId124" style="font-weight: bold;">Share Price Date</label>
                                    <br/>
                                    <span>
                                        {{ specificStockData.sharePriceDateId124?.split(' ')[0] }}
                                    </span>
                                </div>

                                <div class="field col-12 md:col-4">
                                    <label for="peRatioId104" style="font-weight: bold;">PE Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.peRatioId104) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="longtermDebtEquityRatioId084" style="font-weight: bold;">Long-term
                                        Debt/Equity Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.longtermDebtEquityRatioId084) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="afdId004" style="font-weight: bold;">Forward Annual Dividend</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.afdId004) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="pbRatioId102" style="font-weight: bold;">PB Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.pbRatioId102) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="dividendPaidId070" style="font-weight: bold;">Dividends Paid
                                        Since</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendPaidId070 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="firstname2" style="font-weight: bold;">Dividend Yield</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.currentDividendYieldId050) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="marketCapitalisationId090" style="font-weight: bold;">Market
                                        Capitalization</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.marketCapitalisationId090) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="shareBuybackId122" style="font-weight: bold;">Share Buyback?</label>
                                    <br/>

                                    <span v-if="this.specificStockData.shareBuybackId122 === 'Y'">Yes</span>
                                    <span v-else>No</span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="employeesId093" style="font-weight: bold;">Number of Employees</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.employeesId093 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="industryId081" style="font-weight: bold;">Industry</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.industryId081 }}
                                    </span>
                                </div>

                                <div v-show="this.profile.rights != 'C'" class="field col-12 md:col-4">
                                    <label for="undervaluedVsOvervaluedStatusYear20Id135"
                                           style="font-weight: bold;">Undervalued/overvalued
                                        (20-yr)</label>
                                    <br/>
                                    <span
                                        v-if="this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 === 'U'">
                                        Undervalued
                                    </span>
                                    <span
                                        v-else-if="this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 === 'O'">
                                        Overvalued
                                    </span>
                                    <span
                                        v-else-if="this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 === 'Z'">
                                        Overvalued
                                    </span>
                                    <span v-else>Unknown</span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="address" style="font-weight: bold;">Address</label>
                                    <br/>
                                    <span>
                                        {{
                                            this.specificStockData.companyAddressId044 + ', ' +
                                            this.specificStockData.companyAddressCityId041 + ' ' +
                                            this.specificStockData.companyAddressStateId043 + ' ' +
                                            this.specificStockData.companyAddressCountryId042
                                        }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="websiteId136" style="font-weight: bold;">Website</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.websiteId136 }}
                                    </span>
                                </div>
                                <div v-show="this.profile.rights != 'C'" class="field col-12 md:col-4">
                                    <label for="siCriteriaYear20Id128" style="font-weight: bold;">SI Criteria
                                        (20-yr)</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.siCriteriaYear20Id128 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-12">
                                    <label for="companyDescriptionId045" style="font-weight: bold;">Company
                                        Description</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.companyDescriptionId045 }}
                                    </span>
                                </div>

                            </div>

                            <div class="field col-12">&nbsp;</div>

                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <h3>Stock History for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable :value="stockHistory" :striped-rows="true" :reorderableColumns="true"
                                       :rowHover="true" :sortMode="'multiple'" dataKey="id"
                                       class="p-datatable-gridlines">

                                <template #empty>
                                    No stock history found.
                                </template>

                                <Column field="year" header="Year" :sortable="true"
                                        style="max-width: 50px; min-width: 50px" frozen>
                                    <template #body="{ data }">
                                        {{ data.year }}
                                    </template>
                                </Column>

                                <Column field="dividendPerShare" header="Dividend Per Share" :sortable="true"
                                        style="max-width: 50px; min-width: 50px; text-align: right;">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.dividendPerShare || data.dividendPerShare === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.dividendPerShare) }}
                                        </span>

                                    </template>
                                </Column>

                                <Column field="averageDividendYield" header="Average Dividend Yield"
                                        style="max-width: 50px; min-width: 50px" :sortable="true">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.averageDividendYield || data.averageDividendYield === 0)">
                                          avail aft CYE
                                        </span>

                                        <span
                                            v-else-if="data.year === 2025">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.averageDividendYield) }}
                                        </span>
                                    </template>
                                </Column>

                                <Column field="eps" header="EPS" style="max-width: 50px; min-width: 50px"
                                        :sortable="true">
                                    <template #body="{ data }">
                                        <span v-if="data.year === 2025 && (!data.eps || data.eps === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.eps) }}
                                        </span>

                                    </template>
                                </Column>

                                <Column field="averagePeRatio" header="Average P/E Ratio"
                                        style="max-width: 50px; min-width: 50px" :sortable="true">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.averagePeRatio || data.averagePeRatio === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.averagePeRatio) }}
                                        </span>
                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>


                    <div v-show="this.profile.rights != 'C'" class="col-12">
                        <div class="card">
                            <h3>SI Criteria for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable
                                v-model:lazyParams="lazyParams"
                                :value="specificStockDataArray"
                                lazy
                                paginator
                                :rows="100"
                                :totalRecords="totalRecords"
                                :loading="loading"
                                :rowsPerPageOptions="[100, 200, 300, 400]"
                                :sortMode="'multiple'"
                                :rowHover="true"
                                :striped-rows="true"
                                :reorderableColumns="true"
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                :globalFilterFields="['id', 'uniqueId', 'clientName', 'paid', 'description', 'amount']"
                                @page="onPage"
                                @sort="onSort"
                                @filter="onFilter">

                                <template #header>

                                    <div class="col-12">
                                        <div class="card p-fluid">
                                            <div class="grid">

                                                <div class="col-12 lg:col-8 p-3">
                                                    <MultiSelect v-model="selectedColumns"
                                                                 :options="columnConfig"
                                                                 optionLabel="header"
                                                                 optionValue="field"
                                                                 @change="onToggleColumns"
                                                                 display="chip"
                                                                 placeholder="Select Columns"
                                                                 :filter="true"
                                                                 filterPlaceholder="Search columns..."
                                                                 :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                </div>

                                                <div class="col-12 lg:col-2 p-3">
                                                    <Dropdown v-model="selectedCustomFilter"
                                                              :options="customFiltersActive"
                                                              optionLabel="name" optionValue="id"
                                                              placeholder="Select a Custom Filter"
                                                              @change="onCustomFilterChange"/>
                                                </div>

                                                <div class="col-12 lg:col-2 p-3">
                                                    <Dropdown v-model="selectedFormat" :options="formats"
                                                              optionLabel="name"
                                                              optionValue="code" placeholder="Select a Format"
                                                              @change="onFormatChangeForSearch"/>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </template>

                                <template #empty>
                                    No stock data found.
                                </template>

                                <template #loading>
                                    Loading stock data. Please wait.
                                </template>

                                <Column v-for="column in filteredColumnsForSearch" :key="column.field"
                                        :field="column.field"
                                        :sortable="column.sortable" :style="column.style"
                                        :frozen="column.frozen || false">

                                    <template #header>
                                            <span v-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))"
                                                  v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))"
                                              v-tooltip="'[undervalued]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))" v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'pbRatioId102')"
                                              v-tooltip="'[3 or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'peRatioId104')"
                                              v-tooltip="'[25 or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'shareBuybackId122')"
                                              v-tooltip="'[yes]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'afdPreviousId005')"
                                              v-tooltip="'[0% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')"
                                              v-tooltip="'[70% or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'payoutRatioId107')"
                                              v-tooltip="'[75% or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear20Id097')"
                                              v-tooltip="'[8 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear15Id096')"
                                              v-tooltip="'[6 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear10Id095')"
                                              v-tooltip="'[4 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear5Id094')"
                                              v-tooltip="'[2 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else>
                                                {{ column.header }}
                                            </span>
                                    </template>

                                    <template #body="{ data }">

                                            <span v-if="column.field === 'codeId129'">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="column.field === 'sharePriceId123'">
                                                {{ formatAmount(data[column.field]) }}
                                            </span>

                                        <span v-else-if="column.field === 'currentDividendYieldId050'">
                                                {{ formatAmount(data[column.field]) }}%

                                                <span v-if="((data[column.field] > maxDividendYield) &&
                                                    ((this.selectedStandardFilter != 'DOW30') && (this.selectedStandardFilter != 'TSX60')))"
                                                      :class="'status-badge status-DT'"
                                                      @click="handleDividendTrapInfo(data)">DT
                                                </span>

                                            </span>

                                        <span v-else-if="((column.field === 'siCriteriaYear20Id128') ||
                                                (column.field === 'siCriteriaYear15Id127') ||
                                                (column.field === 'siCriteriaYear10Id126') ||
                                                (column.field === 'siCriteriaYear5Id125'))">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="column.field === 'companyNameId046'">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))">

                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                        <span v-else-if="((column.field === 'epsIncreasesYear20Id097') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear5Id094'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 8">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))">
                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                        <span v-else-if="(column.field === 'payoutRatioId107')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'afdPreviousId005')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] >= 0)">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else-if="(data[column.field] === -999999)">
                                                    non-dividend stock
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'shareBuybackId122')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                                <span v-else :class="'highlight'">No</span>
                                            </span>

                                        <span v-else-if="(column.field === 'peRatioId104')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                                <span v-else :class="'highlight'">Over-valued</span>
                                            </span>

                                        <span v-else-if="(column.field === 'pbRatioId102')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                                (column.field === 'yearsEpsIncreasesId048') ||
                                                (column.field === 'employeesId093') ||
                                                (column.field === 'epsIncreasesYear5Id094') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear20Id097'))">
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else>
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                        </span>

                                        <span v-else-if="(column.field === 'sharePriceDateId124')">
                                            {{ data[column.field]?.split(' ')[0] }}
                                        </span>

                                        <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                                (column.field === 'companyAddressCountryId042') ||
                                                (column.field === 'companyAddressStateId043') ||
                                                (column.field === 'companyAddressId044') ||
                                                (column.field === 'companyDescriptionId045') ||
                                                (column.field === 'industryId081') ||
                                                (column.field === 'marketId089') ||
                                                (column.field === 'sectorId121') ||
                                                (column.field === 'websiteId136') ||
                                                (column.field === 'dividendCurrencyId062') ||
                                                (column.field === 'dividendFrequencyId063') ||
                                                (column.field === 'dividendPaymentDateId068') ||
                                                (column.field === 'dividendRecordDateId069') ||
                                                (column.field === 'exDividendDateId074') ||
                                                (column.field === 'fiscalYearendDateId075') ||
                                                (column.field === 'dividendPaidId070'))">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else>
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                                <span v-else>
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>

                    <div v-show="this.profile.rights != 'C'" class="col-12">
                        <div class="card">
                            <h3>Graph for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card p-fluid">
                                    <div class="grid">

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataTimePeriod" :options="timePeriodsGraph"
                                                      optionLabel="name" optionValue="code"
                                                      placeholder="Select a Time Period"
                                                      @change="onStockDataTimePeriodChange"/>
                                        </div>

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataStockHistoryOption"
                                                      :options="stockHistoryOptions" optionLabel="name"
                                                      optionValue="code"
                                                      placeholder="Select a Format"
                                                      @change="onStockDataStockHistoryOptionChange"/>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <Chart type="line" :data="lineData" :options="lineOptions" :key="chartKey"></Chart>
                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Column Definitions</h3>

                    <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>

                    <DataTable
                        :value="columnDefinitions"
                        dataKey="name"
                        :sortMode="'multiple'"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true">

                        <template #empty>
                            No column definitions found.
                        </template>

                        <Column field="id" header="Number" :sortable="true" style="min-width: 50px">
                            <template #body="{ data }">
                                {{ data.id }}
                            </template>
                        </Column>

                        <Column field="uiName" header="Column Name in App" :sortable="true" style="min-width: 200px">
                            <template #body="{ data }">
                                {{ data.uiName }}
                            </template>
                        </Column>

                        <Column field="name" header="Column Name" :sortable="true" style="min-width: 200px">
                            <template #body="{ data }">
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="definition" header="Column Definition" :sortable="true" style="min-width: 300px">
                            <template #body="{ data }">
                                <span v-html="data.definition"></span>
                            </template>
                        </Column>

                    </DataTable>

                    <div class="field col-12">&nbsp;</div>

                    <Button label="Back" class="mr-2 mb-2" @click="restoreToOriginal"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Contact Support</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="supportData.type" :options="supportTypes" optionLabel="name"
                                  optionValue="name"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="description">Short Summary</label>
                        <InputText id="description" v-model.trim="supportData.description" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Detailed Summary</label>
                        <Editor v-model="supportData.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Submit" class="mr-2 mb-2" :loading="loading" @click="processSupport"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="loading" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 12" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Support Request Confirmed</h3>

                    <span>
                        Your support request has been submitted to the Simply Investing team. You will receive a response shortly.
                        <br/>
                    </span>

                    <span>
                        <br/><br/>
                    </span>

                    <Button label="Back" class="mr-2 mb-2" :loading="loading" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 20" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Basic Search</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li v-show="this.profile.rights != 'C'">
                                <a @click="callAdvancedSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Advanced Search</span>
                                </a>
                            </li>

                            <li v-show="this.profile.rights != 'C'">
                                <a @click="callCompareStocks" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Compare Stocks</span>
                                </a>
                            </li>

                            <!--                            <li>-->
                            <!--                                <a @click="callResetHome" v-ripple-->
                            <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                            <!--                                    <i class="pi pi-search mr-2"></i>-->
                            <!--                                    <span>Back to Home</span>-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                        </ul>
                    </div>

                    <div class="field col-12">&nbsp;</div>

                    <div class="card p-fluid">

                        <div class="formgrid grid">

                            <div class="field col">

                                <AutoComplete
                                    placeholder="Search by stock symbol or company name"
                                    :dropdown="false"
                                    :multiple="false"
                                    v-model="searchCriteria"
                                    :suggestions="filteredCodes"
                                    @complete="onComplete"
                                    field="label"
                                    :minLength="2"
                                    :completeOnFocus="false"
                                    :class="{ 'p-invalid': loading && !searchCriteria }"
                                />

                                <!--                                <AutoComplete-->
                                <!--                                    placeholder="Search by stock symbol or company name"-->
                                <!--                                    :dropdown="false"-->
                                <!--                                    :multiple="false"-->
                                <!--                                    v-model="searchCriteria"-->
                                <!--                                    :suggestions="filteredCodes"-->
                                <!--                                    @complete="searchCodes($event)"-->
                                <!--                                    field="label"-->
                                <!--                                    :minLength="2"-->
                                <!--                                    :completeOnFocus="false"-->
                                <!--                                    :class="{ 'p-invalid': loading && !searchCriteria }"-->
                                <!--                                />-->
                            </div>

                            <div class="field col">
                                <Dropdown v-model="selectedCountry" :options="countries" optionLabel="name"
                                          optionValue="code" placeholder="Select Country"/>
                            </div>

                        </div>

                        <Button label="Search" class="mr-2 mb-2" @click="processBasicSearch"></Button>
                        <Button label="Back" class="mr-2 mb-2" @click="callReset"></Button>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 21" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Advanced Search</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBasicSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Basic Search</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callAdvancedSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Advanced Search</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callCompareStocks" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Compare Stocks</span>
                                </a>
                            </li>

                            <!--                            <li>-->
                            <!--                                <a @click="callResetHome" v-ripple-->
                            <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                            <!--                                    <i class="pi pi-search mr-2"></i>-->
                            <!--                                    <span>Back to Home</span>-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                        </ul>
                    </div>

                    <div class="field col-12">&nbsp;</div>

                    <div class="card p-fluid">

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="siCriteria5year">SI Criteria (out of 10) using 5-year data</label>
                                <Dropdown v-model="advancedSearchStockData.siCriteriaYear5Id125"
                                          :options="siCriteriaOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="underOrOverValued5year">Undervalued or Overvalued using 5-year data</label>
                                <Dropdown v-model="advancedSearchStockData.undervaluedVsOvervaluedStatusYear5Id132"
                                          :options="underOrOverValuedOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="siCriteria10year">SI Criteria (out of 10) using 10-year data</label>
                                <Dropdown v-model="advancedSearchStockData.siCriteriaYear10Id126"
                                          :options="siCriteriaOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="underOrOverValued10year">Undervalued or Overvalued using 10-year
                                    data</label>
                                <Dropdown v-model="advancedSearchStockData.undervaluedVsOvervaluedStatusYear10Id133"
                                          :options="underOrOverValuedOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="siCriteria15year">SI Criteria (out of 10) using 15-year data</label>
                                <Dropdown v-model="advancedSearchStockData.siCriteriaYear15Id127"
                                          :options="siCriteriaOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="underOrOverValued15year">Undervalued or Overvalued using 15-year
                                    data</label>
                                <Dropdown v-model="advancedSearchStockData.undervaluedVsOvervaluedStatusYear15Id134"
                                          :options="underOrOverValuedOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="siCriteria20year">SI Criteria (out of 10) using 20-year data</label>
                                <Dropdown v-model="advancedSearchStockData.siCriteriaYear20Id128"
                                          :options="siCriteriaOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="underOrOverValued20year">Undervalued or Overvalued using 20-year
                                    data</label>
                                <Dropdown v-model="advancedSearchStockData.undervaluedVsOvervaluedStatusYear20Id135"
                                          :options="underOrOverValuedOptions" optionLabel="name" optionValue="code"
                                          placeholder="Select a Value"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="market">Exchange</label>
                                <Dropdown v-model="advancedSearchStockData.exchangeId073" :options="exchanges"
                                          optionLabel="name" optionValue="code" placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="sector">Sector</label>
                                <Dropdown v-model="advancedSearchStockData.sectorId121"
                                          :options="sectorData"
                                          placeholder="Select a Value"/>
                            </div>
                        </div>

                        <div class="formgrid grid">
                            <div class="field col">
                                <label for="industry">Industry</label>
                                <Dropdown v-model="advancedSearchStockData.industryId081"
                                          :options="industryData"
                                          placeholder="Select a Value"/>
                            </div>

                            <div class="field col">
                                <label for="consecutiveDividendIncreases">Consecutive Years of Dividend
                                    Increases</label>

                                <Dropdown v-model="advancedSearchStockData.consecutiveDividendIncreasesOption"
                                          :options="consecutiveDividendIncreasesOptions" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select an Option"/>

                                <br/>

                                <InputText
                                    v-show="this.advancedSearchStockData.consecutiveDividendIncreasesOption === -5"
                                    v-model="advancedSearchStockData.consecutiveDividendIncreasesInput"
                                    id="consecutiveDividendIncreasesInput" type="text"
                                    placeholder="Enter your own value"/>
                            </div>

                        </div>

                        <Button label="Search" class="mr-2 mb-2" @click="processAdvancedSearch"></Button>
                        <Button label="Reset" class="mr-2 mb-2" @click="callResetAdvancedSearch"></Button>
                        <Button label="Back" class="mr-2 mb-2" @click="callBasicSearch"></Button>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 22" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Compare Stocks</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBasicSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Basic Search</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callAdvancedSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Advanced Search</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callCompareStocks" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Compare Stocks</span>
                                </a>
                            </li>

                            <!--                            <li>-->
                            <!--                                <a @click="callResetHome" v-ripple-->
                            <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                            <!--                                    <i class="pi pi-search mr-2"></i>-->
                            <!--                                    <span>Back to Home</span>-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                        </ul>
                    </div>

                    <div class="field col-12">&nbsp;</div>

                    <div class="card p-fluid">

                        <div class="formgrid grid">

                            <div class="field col">
                                <InputText v-model="searchCriteria"
                                           placeholder="Enter stock symbols to compare, comma separated"
                                           style="width: 100%"
                                           maxlength="100"/>
                            </div>

                            <div class="field col">
                                <Dropdown v-model="selectedCountry" :options="countries" optionLabel="name"
                                          optionValue="code" placeholder="Select Country"/>
                            </div>

                        </div>

                        <Button label="Compare" class="mr-2 mb-2" @click="processCompareStock"></Button>
                        <Button label="Back" class="mr-2 mb-2" @click="callBasicSearch"></Button>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 23" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Search Results [{{ this.stockData.length }}
                        {{ this.stockData.length === 1 ? 'Entry' : 'Entries' }}]</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a v-if="lastActiveTab === 20" @click="callBasicSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Back to Basic Search</span>
                                </a>

                                <a v-else-if="lastActiveTab === 21" @click="callAdvancedSearch" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Back to Advanced Search</span>
                                </a>

                                <a v-else-if="lastActiveTab === 22" @click="callCompareStocks" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-search mr-2"></i>
                                    <span>Back to Compare Stocks</span>
                                </a>

                                <!--                                <a v-if="lastActiveTab === 29" @click="restoreToOriginal" v-ripple-->
                                <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                                <!--                                    <i class="pi pi-search mr-2"></i>-->
                                <!--                                    <span>Back to Home</span>-->
                                <!--                                </a>-->

                            </li>
                        </ul>
                    </div>

                    <div class="grid" v-show="this.loading === true">
                        <ProgressSpinner v-if="loading" style="width: 16px; height: 16px" strokeWidth="6"
                                         fill="transparent" animationDuration=".5s"
                                         aria-label="Custom ProgressSpinner"/>
                    </div>

                    <div class="grid" v-show="this.loading === false">
                        &nbsp;
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <DataTable
                                    :value="stockData"
                                    lazy
                                    paginator
                                    :rows="lazyParams.rows"
                                    :first="lazyParams.first"
                                    :totalRecords="totalRecords"
                                    :loading="loading"
                                    :sortField="lazyParams.sortField"
                                    :sortOrder="lazyParams.sortOrder"
                                    :filterConstraints="lazyParams.filters"
                                    sortMode="single"
                                    :rowHover="true"
                                    :striped-rows="true"
                                    :reorderableColumns="true"
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    :scrollable="true" scrollDirection="both"
                                    scrollHeight="750px"
                                    :globalFilterFields="['id', 'uniqueId', 'clientName', 'paid', 'description', 'amount']"
                                    @page="onPage"
                                    @sort="onSort"
                                    @filter="onFilter">

                                    <template #header>

                                        <div class="col-12">
                                            <div class="card p-fluid">
                                                <div class="grid">

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-8 p-3">
                                                        <MultiSelect v-model="selectedColumns"
                                                                     :options="columnConfig"
                                                                     optionLabel="header"
                                                                     optionValue="field"
                                                                     @change="onToggleColumns"
                                                                     display="chip"
                                                                     placeholder="Select Columns"
                                                                     :filter="true"
                                                                     filterPlaceholder="Search columns..."
                                                                     :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedCustomFilter"
                                                                  :options="customFiltersActive"
                                                                  optionLabel="name" optionValue="id"
                                                                  placeholder="Select a Custom Filter"
                                                                  @change="onCustomFilterChange"/>
                                                    </div>

                                                    <div v-show="this.profile.rights != 'C'"
                                                         class="col-12 lg:col-2 p-3">
                                                        <Dropdown v-model="selectedFormat" :options="formats"
                                                                  optionLabel="name"
                                                                  optionValue="code" placeholder="Select a Format"
                                                                  @change="onFormatChangeForSearch"/>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                    </template>

                                    <template #empty>
                                        No stock data found.
                                    </template>

                                    <template #loading>
                                        Loading stock data. Please wait.
                                    </template>

                                    <Column v-for="column in filteredColumnsForSearch" :key="column.field"
                                            :field="column.field"
                                            :sortable="column.sortable" :style="column.style"
                                            :frozen="column.frozen || false">

                                        <template #header>
                                            <span v-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))"
                                                  v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))"
                                                  v-tooltip="'[undervalued]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))" v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'pbRatioId102')"
                                                  v-tooltip="'[3 or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'peRatioId104')"
                                                  v-tooltip="'[25 or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'shareBuybackId122')"
                                                  v-tooltip="'[yes]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'afdPreviousId005')"
                                                  v-tooltip="'[0% or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')"
                                                  v-tooltip="'[70% or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'payoutRatioId107')"
                                                  v-tooltip="'[75% or less]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear20Id097')"
                                                  v-tooltip="'[8 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear15Id096')"
                                                  v-tooltip="'[6 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear10Id095')"
                                                  v-tooltip="'[4 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear5Id094')"
                                                  v-tooltip="'[2 or more]'">
                                                {{ column.header }}
                                            </span>

                                            <span v-else>
                                                {{ column.header }}
                                            </span>
                                        </template>

                                        <template #body="{ data }">

                                            <span v-if="column.field === 'codeId129'">
                                                <a href="javascript:void(0)" @click="onCompanyCodeClick(data)">
                                                    {{ data[column.field] }}
                                                </a>
                                            </span>

                                            <span v-else-if="column.field === 'sharePriceId123'">
                                                {{ formatAmount(data[column.field]) }}
                                            </span>

                                            <span v-else-if="column.field === 'currentDividendYieldId050'">
                                                {{ formatAmount(data[column.field]) }}%

                                                <span v-if="((data[column.field] > maxDividendYield) &&
                                                    ((this.selectedStandardFilter != 'DOW30') && (this.selectedStandardFilter != 'TSX60')))"
                                                      :class="'status-badge status-DT'"
                                                      @click="handleDividendTrapInfo(data)">DT
                                                </span>

                                            </span>

                                            <span v-else-if="((column.field === 'siCriteriaYear20Id128') ||
                                                (column.field === 'siCriteriaYear15Id127') ||
                                                (column.field === 'siCriteriaYear10Id126') ||
                                                (column.field === 'siCriteriaYear5Id125'))">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else-if="column.field === 'companyNameId046'">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))">

                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear20Id097')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 8">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear15Id096')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 6">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear10Id095')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 4">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'epsIncreasesYear5Id094')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 2">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))">
                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                            <span v-else-if="(column.field === 'payoutRatioId107')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'afdPreviousId005')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] >= 0)">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else-if="(data[column.field] === -999999)">
                                                    non-dividend stock
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'shareBuybackId122')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                                <span v-else :class="'highlight'">No</span>
                                            </span>

                                            <span v-else-if="(column.field === 'peRatioId104')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                                <span v-else :class="'highlight'">Over-valued</span>
                                            </span>

                                            <span v-else-if="(column.field === 'pbRatioId102')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                                (column.field === 'yearsEpsIncreasesId048') ||
                                                (column.field === 'employeesId093') ||
                                                (column.field === 'epsIncreasesYear5Id094') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear20Id097'))">
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else>
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                            <span v-else-if="(column.field === 'sharePriceDateId124')">
                                                {{ data[column.field]?.split(' ')[0] }}
                                            </span>

                                            <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                                (column.field === 'companyAddressCountryId042') ||
                                                (column.field === 'companyAddressStateId043') ||
                                                (column.field === 'companyAddressId044') ||
                                                (column.field === 'companyDescriptionId045') ||
                                                (column.field === 'industryId081') ||
                                                (column.field === 'marketId089') ||
                                                (column.field === 'sectorId121') ||
                                                (column.field === 'websiteId136') ||
                                                (column.field === 'dividendCurrencyId062') ||
                                                (column.field === 'dividendFrequencyId063') ||
                                                (column.field === 'dividendPaymentDateId068') ||
                                                (column.field === 'dividendRecordDateId069') ||
                                                (column.field === 'exDividendDateId074') ||
                                                (column.field === 'fiscalYearendDateId075') ||
                                                (column.field === 'dividendPaidId070'))">
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else>
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                                <span v-else>
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        </template>
                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 30" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Filters</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewCustomFilter" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Custom Filter</span>
                                </a>
                            </li>
                            <!--                            <li>-->
                            <!--                                <a @click="callResetHome" v-ripple-->
                            <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                            <!--                                    <i class="pi pi-plus-circle mr-2"></i>-->
                            <!--                                    <span>Back to Home</span>-->
                            <!--                                </a>-->
                            <!--                            </li>-->

                        </ul>
                    </div>

                    <DataTable :value="customFilters" :paginator="true" class="p-datatable-gridlines" :rows="100"
                               dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No custom filters found.
                        </template>

                        <template #loading>
                            Loading custom filters. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="loading"
                                        @click="callUpdateCustomFilter(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="loading"
                                        @click="callDeleteCustomFilter(data)"/>

                                <Button v-tooltip="'Configure'" icon="pi pi-eye"
                                        class="p-button-rounded p-button-info m-1" :loading="loading"
                                        @click="callConfigureCustomFilter(data)"/>
                            </template>
                        </Column>

                        <Column field="name" header="Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Name</span>
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 31" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Custom Filter</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newCustomFilter.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Use Top Ranked Criteria?</label>
                        <Dropdown v-model="newCustomFilter.type" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createCustomFilter"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 32" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Custom Filter {{ this.customFilter.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="customFilter.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="customFilter.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateCustomFilter"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 33" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Custom Filter {{ this.customFilter.name }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Custom Filter?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteCustomFilter"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 34" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Configure Custom Filter {{ this.customFilter.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewCustomFilterComponent" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Custom Filter Component</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callResetCustomFilter" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Custom Filters</span>
                                </a>
                            </li>
                            <!--                            <li>-->
                            <!--                                <a @click="callResetHome" v-ripple-->
                            <!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
                            <!--                                    <i class="pi pi-search mr-2"></i>-->
                            <!--                                    <span>Back to Home</span>-->
                            <!--                                </a>-->
                            <!--                            </li>-->

                        </ul>
                    </div>

                    <DataTable :value="customFilterComponents" :paginator="true" class="p-datatable-gridlines"
                               :rows="100" dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true" :reorderableColumns="true" :sortMode="'multiple'"
                               responsiveLayout="scroll">

                        <template #empty>
                            No custom filter components found.
                        </template>

                        <template #loading>
                            Loading custom filter components. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="loading"
                                        @click="callUpdateCustomFilterComponent(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="loading"
                                        @click="callDeleteCustomFilterComponent(data)"/>
                            </template>
                        </Column>

                        <Column field="code" header="Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Name</span>
                                {{ getStockCodeName(data.code) }}
                            </template>
                        </Column>

                        <Column field="operator" header="Operator" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Operator</span>
                                <span v-if="data.operator === 'E'"
                                      :class="'status-badge status-' + data.operator">Equal</span>
                                <span v-if="data.operator === 'N'" :class="'status-badge status-' + data.operator">Not
                                    Equal</span>
                                <span v-if="data.operator === 'G'"
                                      :class="'status-badge status-' + data.operator">Greater Than</span>
                                <span v-if="data.operator === 'L'" :class="'status-badge status-' + data.operator">Less
                                    Than</span>
                                <span v-if="data.operator === 'H'"
                                      :class="'status-badge status-' + data.operator">Greater Than and Equal</span>
                                <span v-if="data.operator === 'M'" :class="'status-badge status-' + data.operator">Less
                                    Than and Equal</span>
                            </template>
                        </Column>

                        <Column field="value" header="Value" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">value</span>
                                {{ data.value }}
                            </template>
                        </Column>

                        <Column field="visible" header="Visible" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Visible</span>
                                <span v-if="data.visible === 'Y'"
                                      :class="'status-badge status-' + data.visible">Yes</span>
                                <span v-if="data.visible === 'N'"
                                      :class="'status-badge status-' + data.visible">No</span>
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 35" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Custom Filter Component</h3>

                    <div class="field">
                        <label for="code">Name</label>
                        <Dropdown
                            v-model="newCustomFilterComponent.code"
                            :options="stockCodes"
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select an Option"
                            filter
                        />
                    </div>

                    <div class="field">
                        <label for="operator">Operator</label>
                        <Dropdown v-model="newCustomFilterComponent.operator" :options="operators" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="newCustomFilterComponent.operator != '0'" class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="newCustomFilterComponent.value" required="true"/>
                    </div>

                    <div class="field">
                        <label for="visible">Visible</label>
                        <Dropdown v-model="newCustomFilterComponent.visible" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="newCustomFilterComponent.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createCustomFilterComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 36" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Custom Filter Component {{ this.customFilterComponent.code }}</h3>

                    <div class="field">
                        <label for="code">Name</label>
                        <Dropdown
                            v-model="customFilterComponent.code"
                            :options="stockCodes"
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select an Option"
                            filter
                        />
                    </div>

                    <div class="field">
                        <label for="operator">Operator</label>
                        <Dropdown v-model="customFilterComponent.operator" :options="operators" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="customFilterComponent.operator != '0'" class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="customFilterComponent.value" required="true"/>
                    </div>

                    <div class="field">
                        <label for="visible">Visible</label>
                        <Dropdown v-model="customFilterComponent.visible" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="customFilterComponent.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateCustomFilterComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 37" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Custom Filter Component {{ this.customFilterComponent.code }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Custom Filter Component?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteCustomFilterComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callResetCustomFilter"></Button>

                </div>
            </div>
        </div>


    </div>


    <SiFooter/>

</template>

<script>
import {
    COLUMN_DEFINITIONS,
    STOCK_DATA_COLUMNS_EXTENDED,
    STOCK_DATA_COLUMNS_FULL,
    STOCK_DATA_COLUMNS_MINIMAL,
    STOCK_DATA_COLUMNS_BASIC_SEARCH,
    STOCK_CODES,
    STOCK_DATA_COLUMNS_COURSE
} from '@/config/stockdata';
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import ProgressSpinner from "primevue/progressspinner";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import numeral from "numeral";
import ClientService from "@/service/ClientService";
import StockDataService from "@/service/StockDataService";
import moment from "moment";
import TaskService from "@/service/TaskService";
import StockService from "@/service/StockService";
import FilterService from "@/service/FilterService";
import FilterComponentService from "@/service/FilterComponentService";
import StockHistoryService from "@/service/StockHistoryService";
import SystemConfigService from "@/service/SystemConfigService";


export default {
    components: {
        MenuSiModuleMain,
        SiFooter,
        ProgressSpinner
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    computed: {
        filteredColumns() {
            const filtered = this.columnConfig.filter(column => {
                const isTimePeriodMatch = !(
                    (column.field.includes('Year20Id') && this.selectedTimePeriod !== '20') ||
                    (column.field.includes('Year15Id') && this.selectedTimePeriod !== '15') ||
                    (column.field.includes('Year10Id') && this.selectedTimePeriod !== '10') ||
                    (column.field.includes('Year5Id') && this.selectedTimePeriod !== '5')
                );

                const isSelectedInMultiSelect = this.selectedColumns.includes(column.field);

                return isTimePeriodMatch && isSelectedInMultiSelect;
            });

            return filtered;
        },
        filteredColumnsForSearch() {
            const filtered = this.columnConfig.filter(column => {
                return this.selectedColumns.includes(column.field);
            });

            return filtered;
        }
    },
    // watch: {
    //     selectedColumns(newValue, oldValue) {
    //         console.warn("WATCHER: selectedColumns changed!");
    //         console.warn("  Old Value:", oldValue, " (Is Array:", Array.isArray(oldValue), ")");
    //         console.warn("  New Value:", newValue, " (Is Array:", Array.isArray(newValue), ")");
    //         if (!Array.isArray(newValue)) {
    //             console.error("CRITICAL: selectedColumns was set to a NON-ARRAY value!");
    //         }
    //     },
    // },
    async mounted() {
        console.log("[Overview][mounted] A.");

        this.loading = true;

        try {
            const [userData, userConfigData, systemConfigData] = await Promise.all([
                UserService.getUser(this.userStore.user.id),
                UserService.getUserConfig(this.userStore.user.id),
                SystemConfigService.getStatus()
            ]);

            this.profile = userData.data;
            this.userConfig = userConfigData.data;
            this.systemConfig = systemConfigData.data;
        } catch (e) {
            console.error("[Overview][mounted] Error fetching user data = ", e);

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;

        }

        console.log("[Overview][mounted] B.");

        console.log("[Overview][mounted] this.systemConfig = ", this.systemConfig);

        try {
            console.log("[Overview][mounted] 0.");

            await this.updateBasicOptions();

            console.log("[Overview][mounted] 1.");

            this.selectedTimePeriod = "20";
            this.selectedFormat = "Minimal";
            this.selectedCustomFilter = null;

            // console.log("[Overview][updateBasicOptions] Exchanges:", this.exchanges);
            // console.log("[Overview][updateBasicOptions] Countries:", this.countries);

            document.title = "Simply Investing"; // Update the browser tab title
            this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

            if (this.exchanges.length > 0) {
                this.selectedExchange = this.exchanges[0].code;
            }

            if (this.countries.length > 0) {
                this.selectedCountry = this.countries[0].code;
            }

            console.log("[Overview][mounted] 2.");

            this.lastActiveTab = 1;
            this.activeFiltersForCounts = [];

            if (this.profile.rights === 'C') {
                this.selectedColumns = this.columnConfigCourse.map(column => column.field);

                this.activeFiltersForCounts.push(this.filterOptionDow30);
                this.activeFiltersForCounts.push(this.filterOptionTsx60);

                this.standardFilters.push(this.filterOptionDow30); // Use 'this.'
                this.standardFilters.push(this.filterOptionTsx60); // Use 'this.'

                this.selectedExchange = "NYSE";

            } else {
                this.selectedColumns = this.columnConfigMinimal.map(column => column.field);

                this.activeFiltersForCounts.push(...this.baseFilterOptions);
                this.activeFiltersForCounts.push(this.filterOptionDow30);
                this.activeFiltersForCounts.push(this.filterOptionTsx60);

                this.standardFilters.push(...this.baseFilterOptions); // Use 'this.'

                if (this.userConfig.enableSiUs === 'Y') {
                    this.standardFilters.push(this.filterOptionDow30); // Use 'this.'
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.standardFilters.push(this.filterOptionTsx60); // Use 'this.'
                }

                this.selectedStandardFilter = "TR";

            }

            console.log("[Overview][mounted] 3.");

            await this.loadData();

            console.log("[Overview][mounted] 4.");
        } catch (e) {
            console.error("[Overview][mounted] Error fetching data = ", e);
            this.stockData = [];
            this.totalRecords = 0;

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        } finally {
            this.loading = false;
        }

        this.loading = false;
    },
    data() {

        return {
            debounceId: null,   // was _debounceId
            abortCtrl: null,    // was _abortCtrl
            requestSeq: 0,
            activeTab: 1,
            lastActiveTab: 1,
            totalRecords: 0,
            maxDividendYield: 0.0,
            loading: false,
            selectedFormat: "Minimal",
            selectedTimePeriod: "20",
            selectedCustomCriteria: "",
            confirmationResponse: 'N',
            searchCriteria: "",
            selectedStockDataTimePeriod: "20",
            selectedStockDataStockHistoryOption: "DPS",
            chartKey: 0,
            selectedExchange: null,
            selectedStandardFilter: null,
            selectedCountry: null,
            selectedCustomFilter: null,
            payments: null,
            columnsDefault: null,
            filters: null,
            columnConfig: STOCK_DATA_COLUMNS_FULL,
            columnConfigMinimal: STOCK_DATA_COLUMNS_MINIMAL,
            columnConfigExtended: STOCK_DATA_COLUMNS_EXTENDED,
            columnConfigBasicSearch: STOCK_DATA_COLUMNS_BASIC_SEARCH,
            columnConfigCourse: STOCK_DATA_COLUMNS_COURSE,
            columnDefinitions: COLUMN_DEFINITIONS,
            stockCodes: STOCK_CODES,
            profile: {},
            userConfig: {},
            systemConfig: {},
            supportData: {},
            newTask: {},
            client: {},
            newCustomFilter: {},
            customFilter: {},
            advancedSearchStockData: {},
            newCustomFilterComponent: {},
            customFilterComponent: {},
            filterCounts: {},
            specificStockData: {},
            lazyParams: {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: null
            },
            countries: [],
            exchanges: [],
            standardFilters: [],
            customFiltersActive: [],
            customFilterComponents: [],
            customFilterStockDataList: [],
            stockData: [],
            sectorData: [],
            // industryData: [],
            industryData: [
                "Advertising Agencies",
                "Aerospace & Defense",
                "Agricultural - Commodities/Milling",
                "Agricultural - Machinery",
                "Agricultural Farm Products",
                "Agricultural Inputs",
                "Airlines, Airports & Air Services",
                "Aluminum",
                "Apparel - Footwear & Accessories",
                "Apparel - Manufacturers",
                "Apparel - Retail",
                "Asset Management",
                "Asset Management - Bonds",
                "Asset Management - Cryptocurrency",
                "Asset Management - Global",
                "Asset Management - Income",
                "Asset Management - Leveraged",
                "Auto - Dealerships",
                "Auto - Manufacturers",
                "Auto - Parts",
                "Auto - Recreational Vehicles",
                "Banks",
                "Banks - Diversified",
                "Banks - Regional",
                "Beverages - Alcoholic",
                "Beverages - Non-Alcoholic",
                "Beverages - Wineries & Distilleries",
                "Biotechnology",
                "Broadcasting",
                "Business Equipment & Supplies",
                "Chemicals",
                "Chemicals - Specialty",
                "Coal",
                "Communication Equipment",
                "Computer Hardware",
                "Conglomerates",
                "Construction",
                "Construction Materials",
                "Consulting Services",
                "Consumer Electronics",
                "Copper",
                "Department Stores",
                "Discount Stores",
                "Diversified Utilities",
                "Drug Manufacturers - General",
                "Drug Manufacturers - Specialty & Generic",
                "Education & Training Services",
                "Electrical Equipment & Parts",
                "Electronic Gaming & Multimedia",
                "Engineering & Construction",
                "Entertainment",
                "Environmental Services",
                "Financial - Capital Markets",
                "Financial - Conglomerates",
                "Financial - Credit Services",
                "Financial - Data & Stock Exchanges",
                "Financial - Diversified",
                "Financial - Mortgages",
                "Food Confectioners",
                "Food Distribution",
                "Furnishings, Fixtures & Appliances",
                "Gambling, Resorts & Casinos",
                "General Transportation",
                "General Utilities",
                "Gold",
                "Grocery Stores",
                "Hardware, Equipment & Parts",
                "Home Improvement",
                "Household & Personal Products",
                "Independent Power Producers",
                "Industrial - Capital Goods",
                "Industrial - Distribution",
                "Industrial - Infrastructure Operations",
                "Industrial - Machinery",
                "Industrial - Pollution & Treatment Controls",
                "Industrial - Specialties",
                "Industrial Materials",
                "Information Technology Services",
                "Insurance - Brokers",
                "Insurance - Diversified",
                "Insurance - Life",
                "Insurance - Property & Casualty",
                "Insurance - Reinsurance",
                "Insurance - Specialty",
                "Integrated Freight & Logistics",
                "Internet Content & Information",
                "Investment - Banking & Investment Services",
                "Leisure",
                "Luxury Goods",
                "Manufacturing - Metal Fabrication",
                "Manufacturing - Miscellaneous",
                "Manufacturing - Textiles",
                "Manufacturing - Tools & Accessories",
                "Marine Shipping",
                "Media & Entertainment",
                "Medical - Care Facilities",
                "Medical - Devices",
                "Medical - Diagnostics & Research",
                "Medical - Distribution",
                "Medical - Equipment & Services",
                "Medical - Healthcare Information Services",
                "Medical - Healthcare Plans",
                "Medical - Instruments & Supplies",
                "Medical - Pharmaceuticals",
                "Medical - Specialties",
                "Oil & Gas Drilling",
                "Oil & Gas Energy",
                "Oil & Gas Equipment & Services",
                "Oil & Gas Exploration & Production",
                "Oil & Gas Integrated",
                "Oil & Gas Midstream",
                "Oil & Gas Refining & Marketing",
                "Other Precious Metals",
                "Packaging & Containers",
                "Packaged Foods",
                "Paper, Lumber & Forest Products",
                "Personal Products & Services",
                "Publishing",
                "Railroads",
                "Real Estate - Development",
                "Real Estate - Diversified",
                "Real Estate - General",
                "Real Estate - Services",
                "REIT - Diversified",
                "REIT - Healthcare Facilities",
                "REIT - Hotel & Motel",
                "REIT - Industrial",
                "REIT - Mortgage",
                "REIT - Office",
                "REIT - Residential",
                "REIT - Retail",
                "REIT - Specialty",
                "Regulated Electric",
                "Regulated Gas",
                "Regulated Water",
                "Rental & Leasing Services",
                "Renewable Utilities",
                "Restaurants",
                "Residential Construction",
                "Security & Protection Services",
                "Semiconductors",
                "Shell Companies",
                "Silver",
                "Solar",
                "Software - Application",
                "Software - Infrastructure",
                "Software - Services",
                "Specialty Business Services",
                "Specialty Retail",
                "Staffing & Employment Services",
                "Steel",
                "Telecommunications Services",
                "Technology Distributors",
                "Tobacco",
                "Travel Lodging",
                "Travel Services",
                "Trucking",
                "Uranium",
                "Waste Management"
            ],
            selectedColumns: STOCK_DATA_COLUMNS_MINIMAL.map(column => column.field), // <-- FIX THIS LINE
            filteredCodes:
                [],
            searchStockData:
                [],
            advancedSearchStockDataList:
                [],
            industryDropdownData:
                [],
            stockHistory:
                [],
            specificStockDataArray:
                [],
            lineData:
                [],
            lineOptions:
                [],
            activeFiltersForCounts:
                [],
            baseCountryOptions:
                [
                    {name: 'USA', code: 'US'},
                    {name: 'Canada', code: 'CA'},
                    {name: 'UK', code: 'UK'},
                    {name: 'South Africa', code: 'ZA'},
                ],
            baseExchangeOptions:
                [
                    {name: 'NYSE', code: 'NYSE'},
                    {name: 'NASDAQ', code: 'NASDAQ'},
                    {name: 'TSX', code: 'TO'},
                    {name: 'LSE', code: 'LSE'},
                    {name: 'JSE', code: 'JSE'},
                ],
            baseFilterOptions:
                [
                    {name: 'Top Ranked', code: 'TR'},
                    {name: 'Runners-Up', code: 'RU'},
                    {name: 'Dividend Stocks Under-valued', code: 'DSU'},
                    {name: 'Dividend Stocks Over-valued', code: 'DSO'},
                    {name: 'Dividend Stocks Deep-valued', code: 'DSD'},
                    {name: 'Non Dividend Stocks Under-valued', code: 'NDSU'},
                    {name: 'Non Dividend Stocks Over-valued', code: 'NDSO'},
                    {name: 'Non Dividend Stocks Deep-valued', code: 'NDSD'},
                ],
            filterOptionDow30:
                {
                    name: 'DOW 30', code:
                        'DOW30'
                }
            ,
            filterOptionTsx60: {
                name: 'TSX 60', code:
                    'TSX60'
            }
            ,
            customFilters: [],
            timePeriods:
                [
                    {name: '20 Year', code: '20'},
                    {name: '15 Year', code: '15'},
                    {name: '10 Year', code: '10'},
                    {name: '5 Year', code: '5'}
                ],
            timePeriodsGraph:
                [
                    {name: '20 Year', code: '20'},
                    {name: '15 Year', code: '15'},
                    {name: '10 Year', code: '10'},
                    {name: '5 Year', code: '5'},
                    {name: 'Maximum', code: 'Maximum'},
                ],
            formats:
                [
                    {name: 'Minimal View', code: 'Minimal'},
                    {name: 'Extended View', code: 'Extended'}
                ],
            stockHistoryOptions:
                [
                    {name: 'Dividends Per Share', code: 'DPS'},
                    {name: 'Low Price', code: 'LSP'},
                    {name: 'High Price', code: 'HSP'},
                    {name: 'Average Price', code: 'ASP'},
                    {name: 'EPS', code: 'EPS'}
                ],
            supportTypes:
                [
                    {name: 'Technical Issue', code: 'Technical Issue'},
                    {name: 'Billing & Payments', code: 'Billing & Payments'},
                    {name: 'Account Management', code: 'Account Management'},
                    {name: 'Feature Request', code: 'Feature Request'},
                    {name: 'How-To / Usage Questions', code: 'How-To / Usage Questions'},
                    {name: 'Performance Issues', code: 'Performance Issues'},
                    {name: 'Other', code: 'Other'}
                ],
            siCriteriaOptions:
                [
                    {name: '1 out of 10', code: 1},
                    {name: '2 out of 10', code: 2},
                    {name: '3 out of 10', code: 3},
                    {name: '4 out of 10', code: 4},
                    {name: '5 out of 10', code: 5},
                    {name: '6 out of 10', code: 6},
                    {name: '7 out of 10', code: 7},
                    {name: '8 out of 10', code: 8},
                    {name: '9 out of 10', code: 9},
                    {name: '10 out of 10', code: 10}
                ],
            confirmationTypes:
                [
                    {name: 'Yes', code: 'Y'},
                    {name: 'No', code: 'N'}
                ],
            statusTypes:
                [
                    {name: 'Active', code: 'A'},
                    {name: 'Inactive', code: 'I'}
                ],
            operators:
                [
                    {name: 'Equal', code: 'E'},
                    {name: 'Not Equal', code: 'N'},
                    {name: 'Greater Than', code: 'G'},
                    {name: 'Less Than', code: 'L'},
                    {name: 'Greater Than and Equal', code: 'H'},
                    {name: 'Less Than and Equal', code: 'M'},
                    {name: 'None Needed', code: '0'}
                ],
            underOrOverValuedOptions:
                [
                    {name: 'Undervalued', code: 'U'},
                    {name: 'Overvalued', code: 'O'}
                ],
            consecutiveDividendIncreasesOptions:
                [
                    {name: '10 to 14 Years (Achievers)', code: -1},
                    {name: '15 to 24 Years (Contenders)', code: -2},
                    {name: '25 to 49 Years (Aristocrats/Champions)', code: -3},
                    {name: '50 Years or more (Kings)', code: -4},
                    {name: 'Enter your own value', code: -5},
                ],

        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        onComplete(event) {
            console.log('[Overview][onComplete] event = ', event);

            const q = (event?.query || '').trim();

            if (q.length < 2) {
                this.filteredCodes = [];
                this.cancelPending();
                return;
            }

            // Debounce 300 ms
            clearTimeout(this.debounceId);
            this.debounceId = setTimeout(() => this.doSearch(q), 300);
        },

        cancelPending() {
            if (this.abortCtrl) {
                this.abortCtrl.abort();
                this.abortCtrl = null;
            }
        },

        doSearch(query) {
            console.log('[Overview][doSearch] query = ', query);
            console.log('[Overview][doSearch] this.selectedCountry = ', this.selectedCountry);

            // cancel any in-flight request
            this.cancelPending();

            // new controller for this request
            this.abortCtrl = new AbortController();

            // bump sequence to ignore stale responses
            const seq = ++this.requestSeq;

            StockService.searchStocksForCountryByName(
                this.selectedCountry,
                query.toLowerCase(),
                {signal: this.abortCtrl.signal} // axios supports AbortController
            )
                .then((res) => {
                    if (seq !== this.requestSeq) return; // ignore stale

                    const list = res.data || [];
                    this.filteredCodes = list.map((stock) => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code,
                    }));
                })
                .catch((e) => {
                    // ignore aborts
                    if (e.name === 'CanceledError' || e.code === 'ERR_CANCELED') return;

                    console.log('[Overview][searchCodes] Error = ', e);
                    if (e.response && e.response.status === 401) {
                        this.$router.replace('/siLogin');
                    } else {
                        this.userStore.clearUser();
                        this.$router.replace('/siLogin');
                    }
                })
                .finally(() => {
                    this.abortCtrl = null;
                });
        },
        async updateBasicOptions() {
            this.exchanges = [];
            if (this.profile.rights === 'C') {
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NYSE'));
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NASDAQ'));
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'TO'));
            } else {
                if (this.userConfig.enableSiUs === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NYSE'));
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NASDAQ'));
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'TO'));
                }
                if (this.userConfig.enableSiUk === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'LSE'));
                }
                if (this.userConfig.enableSiZa === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'JSE'));
                }
            }
            this.exchanges = this.exchanges.filter(Boolean); // Filter out any undefineds


            // Populate Countries based on user rights
            this.countries = [];
            if (this.profile.rights === 'C') {
                this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'US'));
                this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'CA'));
            } else {
                if (this.userConfig.enableSiUs === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'US'));
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'CA'));
                }
                if (this.userConfig.enableSiUk === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'UK'));
                }
                if (this.userConfig.enableSiZa === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'ZA'));
                }
            }
            this.countries = this.countries.filter(Boolean);
        },
        async updateStandardFiltersWithCounts() {

            let activeFilters = [];

            if (this.profile.rights === 'C') {
                activeFilters.push(this.filterOptionDow30); // Use 'this.'
                activeFilters.push(this.filterOptionTsx60); // Use 'this.'
            } else {
                activeFilters.push(...this.baseFilterOptions); // Use 'this.'

                if (this.userConfig.enableSiUs === 'Y') {
                    activeFilters.push(this.filterOptionDow30); // Use 'this.'
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    activeFilters.push(this.filterOptionTsx60); // Use 'this.'
                }
            }

            console.log("[Overview][updateStandardFiltersWithCounts] this.filterCounts = ", this.filterCounts);
            console.log("[Overview][updateStandardFiltersWithCounts] activeFilters = ", activeFilters);

            activeFilters.forEach(filter => {
                if (filter.code !== undefined && this.filterCounts[filter.code] !== undefined) {
                    filter.count = this.filterCounts[filter.code];
                } else {
                    console.warn(`Count not found or filter code missing for filter:`, filter);
                    filter.count = 0; // Or set to a default value like 0
                }
            });

            console.log("[Overview][updateStandardFiltersWithCounts] activeFilters = ", activeFilters);

            const counts = this.filterCounts;
            this.standardFilters = activeFilters.map(filter => {
                const count = counts[filter.code] !== undefined ? counts[filter.code] : 0;
                return {
                    ...filter,
                    name: `${filter.name} (${count})`
                };
            });
        },
        async loadData() {
            this.loading = true;
            try {
                console.log("[Overview][loadData] Before calling getStockDataCountsByFilter");

                // const filtersToCount = this.activeFiltersForCounts.map(f => f.code);

                const [clientData, customFilterInfo,
                    customFilterActiveInfo, dividendTrapInfo, countInfo] = await Promise.all([
                    ClientService.getClientForUser(this.userStore.user.id),
                    FilterService.getUserFilters(this.userStore.user.id),
                    FilterService.getUserActiveFilters(this.userStore.user.id),
                    StockDataService.findDividendTrapForExchange(this.selectedExchange, 'S'),
                    StockDataService.getStockDataCountsByFilterNew(this.selectedExchange, 'S',
                        "",
                        this.selectedTimePeriod)
                ]);

                console.log("[Overview][loadData] After calling getStockDataCountsByFilter. countInfo = ", countInfo);

                console.log("[Overview][loadData] Before calling getAllStockDataForExchangeLazyLoading");

                const {data, totalRecords} =
                    await StockDataService.getAllStockDataForExchangeLazyLoading(
                        this.selectedExchange, 'S',
                        this.lazyParams,
                        this.filters['global']?.value || '',
                        this.selectedStandardFilter,
                        this.selectedTimePeriod,
                        this.lazyParams.customFilterId);

                console.log("[Overview][loadData] After calling getAllStockDataForExchangeLazyLoading");

                this.stockData = data;
                this.totalRecords = totalRecords;

                this.client = clientData.data;

                this.customFilters = customFilterInfo.data;
                this.customFiltersActive = customFilterActiveInfo.data;

                this.maxDividendYield = dividendTrapInfo.data;

                this.filterCounts = countInfo;

                await this.updateStandardFiltersWithCounts();

            } catch (e) {
                console.error("[Payments][loadData] Error loading payments:", e);
                this.payments = [];
                this.totalRecords = 0;

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }
            this.loading = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            console.log("[Overview][onSort] this.activeTab = ", this.activeTab);
            console.log("[Overview][onSort] this.lastActiveTab = ", this.lastActiveTab);

            const isSearchTab = this.activeTab === 23;

            console.log("[Overview][onSort] isSearchTab = ", isSearchTab);

            if (isSearchTab) {
                if (!event.sortField) {
                    return;
                }

                const field = event.sortField;
                const dir = event.sortOrder; // 1 = asc, -1 = desc

                this.stockData.sort((a, b) => {
                    const va = a[field], vb = b[field];
                    if (va == null && vb == null) return 0;
                    if (va == null) return 1 * dir;
                    if (vb == null) return -1 * dir;
                    if (va < vb) return -1 * dir;
                    if (va > vb) return 1 * dir;
                    return 0;
                });

                return;
            }

            if (event.sortField) {
                this.lazyParams.sortField = event.sortField;
                this.lazyParams.sortOrder = event.sortOrder;
            } else {
                this.lazyParams.sortField = null;
                this.lazyParams.sortOrder = null;
            }
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            this.lazyParams.first = 0;
            this.loadData();
        },
        onToggleStandardFilters() {
            this.lazyParams.first = 0;
            this.loadData();
        },
        clearFilter() {
            this.initFilters();
            this.selectedStandardFilter = null;
            this.lazyParams.filters = {};
            this.lazyParams.first = 0;
            this.loadData();
        },
        async restoreToOriginal() {
            this.$router.go(0);
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'uniqueId': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'clientName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'paid': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'amount': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        callResetHome() {
            this.lastActiveTab = 1;
            this.selectedCustomFilter = null;
            this.activeTab = 1;
        },
        callReset() {
            console.log("[Overview][callReset] this.lastActiveTab = ", this.lastActiveTab);

            if (this.lastActiveTab === 1) {
                // this.lastActiveTab = 1;
                this.selectedCustomFilter = null;
                this.activeTab = 1;
            } else {
                this.selectedCustomFilter = null;
                this.activeTab = 23;
            }
        },
        async callResetAdvancedSearch() {
            this.activeTab = 21;
            this.advancedSearchStockData.siCriteriaYear5Id125 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear5Id132 = null;
            this.advancedSearchStockData.siCriteriaYear10Id126 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear10Id133 = null;
            this.advancedSearchStockData.siCriteriaYear15Id127 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear15Id134 = null;
            this.advancedSearchStockData.siCriteriaYear20Id128 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear20Id135 = null;
            this.advancedSearchStockData.exchangeId073 = null;
            this.advancedSearchStockData.sectorId121 = null;
            this.advancedSearchStockData.industryId081 = null;
            this.advancedSearchStockData.yearsDividendIncreasesId047 = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesInput = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesOption = null;
        },
        onToggleColumns(event) {
            this.selectedColumns = event.value;
        },
        handleDividendTrapInfo() {
            this.activeTab = 3;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0');
            } else {
                return '0';
            }
        },
        formatString(value) {
            if (value) {
                return String(value).substring(0, 50);
            } else {
                return '';
            }
        },
        async onFilterChange() {
            this.selectedCustomFilter = null;
            await this.loadData();
        },
        async onExchangeChange() {
            this.selectedCustomFilter = null;

            await this.loadData();
        },
        async onTimePeriodChange() {
            this.selectedCustomFilter = null;

            await this.loadData();
        },
        onFormatChange() {
            this.selectedCustomFilter = null;

            if (this.selectedFormat === "Minimal") {
                this.selectedColumns = this.columnConfigMinimal.map(column => column.field);
            } else {
                this.selectedColumns = this.columnConfigExtended.map(column => column.field);
            }
        },
        onFormatChangeForSearch() {
            this.selectedCustomFilter = null;

            if (this.selectedFormat === "Minimal") {
                this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
            } else {
                this.selectedColumns = this.columnConfigExtended.map(column => column.field);
            }
        },
        callBasicSearch() {
            if (this.countries.length > 0) {
                this.selectedCountry = this.countries[0].code;
            }

            this.searchCriteria = "";
            this.activeTab = 20;
        },
        async callAdvancedSearch() {
            this.activeTab = 21;

            const [sectorDataInfo] = await Promise.all([
                StockDataService.findSectorForExchange(this.selectedExchange, 'S'),
            ]);

            this.sectorData = sectorDataInfo.data;
        },
        callCompareStocks() {
            this.selectedCountry = "US";
            this.searchCriteria = "";
            this.activeTab = 22;
        },
        callColumnDefinitions() {
            this.activeTab = 10;
        },
        callSupport() {
            this.supportData = {};
            this.supportData.type = "Feature Request";

            this.newTask = {
                type: 'S',
                severity: 'N',
                category: 'F',
                priority: 1,
                max: 259200,
                clientVisible: 'N',
                due: moment().add(5, 'days').startOf('hour').toDate()
            };

            this.activeTab = 11;
        },
        async processSupport() {
            this.loading = true;

            if (this.supportData.description) {

                try {
                    this.newTask = {
                        type: 'S',
                        severity: 'N',
                        category: 'F',
                        priority: 1,
                        max: 259200,
                        clientVisible: 'N',
                        due: moment().add(5, 'days').startOf('hour').toDate()
                    };

                    var newTaskDto = {
                        companyId: this.profile.companyId,
                        requesterId: this.userStore.user.id,
                        clientId: this.client.id,
                        description: 'Overview Page :: ' + this.supportData.type + ' :: ' + this.supportData.description,
                        max: this.newTask.max,
                        type: this.newTask.type,
                        severity: this.newTask.severity,
                        category: this.newTask.category,
                        priority: this.newTask.priority,
                        note: this.supportData.note,
                        clientVisible: this.newTask.clientVisible,
                        due: moment(this.newTask.due).format('YYYY-MM-DD HH:mm'),
                    };

                    await TaskService.createTask(this.profile.companyId, newTaskDto);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created support request',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][processSupport] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create support request. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 12;
            this.loading = false;
        },
        searchCodes(event) {
            StockService.searchStocksForCountryByName(this.selectedCountry, event.query.toLowerCase())
                .then(data => {
                    this.filteredCodes = data.data.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code // or the entire stock object, depending on your needs
                    }));
                })
                .catch(e => {
                    console.log("[Overview][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                });

        },
        async processBasicSearch() {
            this.loading = true;

            if (this.searchCriteria.value === '') {
                this.activeTab = 20;
            } else {
                // const [stockDataInfo] = await Promise.all([
                //     StockDataService.searchStockDataForCountryAndSpecificCode(
                //         this.selectedCountry, 'S', this.searchCriteria.value, this.lazyParams)
                // ]);
                //
                // this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                // this.totalRecords = stockDataInfo.data?.totalElements || 0;

                const [stockDataInfo] = await Promise.all([
                    StockDataService.searchStockDataForCountryAndTypeAndAnyCodeExtended(
                        this.selectedCountry, 'S', this.searchCriteria.value)
                ]);

                this.stockData = Array.isArray(stockDataInfo) ? stockDataInfo : [];

                console.log("[Overview][processBasicSearch] this.stockData = ", this.stockData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 23;
                    this.lastActiveTab = 29;
                    this.selectedColumns = this.columnConfigCourse.map(column => column.field);

                } else {
                    this.activeTab = 23;
                    this.lastActiveTab = 20;
                    this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
                }

                this.selectedTimePeriod = "20";
                this.selectedFormat = "Minimal";
            }

            this.loading = false;
        },
        async processCompareStock() {
            this.loading = true;
            this.lastActiveTab = 22;

            if (this.searchCriteria.trim() === '') {
                this.activeTab = 22;
            } else {
                // const [stockDataInfo] = await Promise.all([
                //     StockDataService.searchStockDataForCountryAndSpecificCode(
                //         this.selectedCountry, 'S', this.searchCriteria.trim(), this.lazyParams)
                // ]);
                //
                // this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                // this.totalRecords = stockDataInfo.data?.totalElements || 0;

                const [stockDataInfo] = await Promise.all([
                    StockDataService.searchStockDataForCountryAndTypeAndAnyCodeExtended(
                        this.selectedCountry, 'S', this.searchCriteria.trim())
                ]);

                this.stockData = Array.isArray(stockDataInfo) ? stockDataInfo : [];

                console.log("[Overview][processCompareStock] this.stockData = ", this.stockData);

                this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
                this.selectedFormat = "Minimal";
                this.selectedTimePeriod = "20";

                this.activeTab = 23;
            }

            this.loading = false;
        },
        async processAdvancedSearch() {

            this.loading = true;
            this.lastActiveTab = 21;

            if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -1) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 10;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 14;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -2) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 15;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 24;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -3) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 25;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 49;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -4) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 50;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 200;
            } else {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
                this.advancedSearchStockData.yearsDividendIncreasesId047End = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
            }

            try {
                console.log("[Overview][processAdvancedSearch] this.advancedSearchStockData = ", this.advancedSearchStockData);

                const [stockDataInfo] = await Promise.all([
                    StockDataService.processAdvancedSearchForStockDataExtended(this.advancedSearchStockData)
                ]);

                this.stockData = stockDataInfo;

                console.log("[Overview][processAdvancedSearch] this.stockData = ", this.stockData);

                this.loading = false;

            } catch (e) {
                console.log("[Overview][processAdvancedSearch] error = ", e);
                this.stockData = {};

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            } finally {
                this.loading = false;
            }

            this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
            this.selectedFormat = "Minimal";
            this.selectedTimePeriod = "20";

            this.activeTab = 23;

        },
        async callManageFilters() {
            this.activeTab = 30;
            this.customFilter = {};

            try {
                const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                    FilterService.getUserFilters(this.userStore.user.id),
                    FilterService.getUserActiveFilters(this.userStore.user.id)
                ]);

                this.customFilters = customFilterInfo.data;
                this.customFiltersActive = customFilterActiveInfo.data;

            } catch (e) {
                console.error("[Overview][callManageFilters] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }
        },
        callNewCustomFilter() {
            this.newCustomFilter = {};
            this.newCustomFilter.type = 'N';
            this.activeTab = 31;
        },
        callUpdateCustomFilter(data) {
            this.customFilter = data;
            this.activeTab = 32;
        },
        callDeleteCustomFilter(data) {
            this.customFilter = data;
            this.confirmationResponse = 'N';
            this.activeTab = 33;
        },
        async callConfigureCustomFilter(data) {
            this.customFilter = data;
            this.activeTab = 34;

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                ]);

                this.customFilterComponents = customFilterComponentsInfo.data;

                console.log("[Overview][callConfigureCustomFilter] this.customFilterComponents = ", this.customFilterComponents);

            } catch (e) {
                console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        },
        callNewCustomFilterComponent() {
            this.newCustomFilterComponent = {};
            this.newCustomFilterComponent.visible = 'Y';
            this.newCustomFilterComponent.status = 'A';
            this.newCustomFilterComponent.operator = 'E';
            this.activeTab = 35;
        },
        callUpdateCustomFilterComponent(data) {
            this.customFilterComponent = data;
            this.activeTab = 36;
        },
        callDeleteCustomFilterComponent(data) {
            this.customFilterComponent = data;
            this.confirmationResponse = 'N';
            this.activeTab = 37;
        },
        async createCustomFilter() {
            this.loading = true;

            if (this.newCustomFilter.name) {

                try {
                    var customFilterDto = {
                        name: this.newCustomFilter.name,
                        status: 'A'
                    };

                    if (this.newCustomFilter.type === 'Y') {
                        await FilterService.createFilterWithType(this.userStore.user.id, "T", customFilterDto);
                    } else {
                        await FilterService.createFilter(this.userStore.user.id, customFilterDto);
                    }

                    try {
                        const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                            FilterService.getUserFilters(this.userStore.user.id),
                            FilterService.getUserActiveFilters(this.userStore.user.id)
                        ]);

                        this.customFilters = customFilterInfo.data;
                        this.customFiltersActive = customFilterActiveInfo.data;

                    } catch (e) {
                        console.error("[Overview][callManageFilters] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 30;
            this.loading = false;
        },
        async updateCustomFilter() {
            this.loading = true;

            if (this.customFilter.id) {

                try {
                    var customFilterDto = {
                        name: this.customFilter.name,
                        status: this.customFilter.status
                    };

                    await FilterService.updateFilter(this.customFilter.id, customFilterDto);

                    const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                        FilterService.getUserFilters(this.userStore.user.id),
                        FilterService.getUserActiveFilters(this.userStore.user.id)
                    ]);

                    this.customFilters = customFilterInfo.data;
                    this.customFiltersActive = customFilterActiveInfo.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][updateCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 30;
            this.loading = false;
        },
        async deleteCustomFilter() {
            this.loading = true;

            if (this.customFilter.id) {

                try {
                    await FilterService.deleteFilter(this.customFilter.id);

                    const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                        FilterService.getUserFilters(this.userStore.user.id),
                        FilterService.getUserActiveFilters(this.userStore.user.id)
                    ]);

                    this.customFilters = customFilterInfo.data;
                    this.customFiltersActive = customFilterActiveInfo.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][deleteCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 30;
            this.loading = false;
        },
        async createCustomFilterComponent() {
            this.loading = true;

            if (this.newCustomFilterComponent.code) {

                try {

                    if (this.newCustomFilterComponent.operator === '0') {
                        this.newCustomFilterComponent.value = null;
                    }

                    var customFilterComponentDto = {
                        code: this.newCustomFilterComponent.code,
                        operator: this.newCustomFilterComponent.operator,
                        value: this.newCustomFilterComponent.value,
                        visible: this.newCustomFilterComponent.visible,
                        status: this.newCustomFilterComponent.status
                    };

                    await FilterComponentService.createFilterComponent(this.customFilter.id, customFilterComponentDto);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        async updateCustomFilterComponent() {
            this.loading = true;

            if (this.customFilterComponent.code) {

                try {
                    if (this.customFilterComponent.operator === '0') {
                        this.customFilterComponent.value = null;
                    }

                    var customFilterComponentDto = {
                        code: this.customFilterComponent.code,
                        operator: this.customFilterComponent.operator,
                        value: this.customFilterComponent.value,
                        visible: this.customFilterComponent.visible,
                        status: this.customFilterComponent.status
                    };

                    await FilterComponentService.updateFilterComponent(this.customFilterComponent.id, customFilterComponentDto);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;
                        // console.log("[Overview][callConfigureCustomFilter] this.customFilterComponents = ", this.customFilterComponents);

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        async deleteCustomFilterComponent() {
            this.loading = true;

            if (this.customFilterComponent.id) {

                try {
                    await FilterComponentService.deleteFilterComponent(this.customFilterComponent.id);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        callResetCustomFilter() {
            this.selectedCustomFilter = null;
            this.activeTab = 30;
        },
        getStockCodeName(code) {
            const stock = this.stockCodes.find(stock => stock.code === code);
            return stock ? stock.name : 'Unknown Code';
        },
        async onCustomFilterChange() {

            this.loading = true;

            if ((this.lastActiveTab === 20) ||
                (this.lastActiveTab === 21) ||
                (this.lastActiveTab === 22)) {
                this.activeTab = 23;
            } else if (this.lastActiveTab === 4) {
                this.activeTab = 4;
            } else {
                this.activeTab = 1;
            }

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.selectedCustomFilter)
                ]);
                this.customFilterComponents = customFilterComponentsInfo.data;
            } catch (e) {
                console.error("[Overview][onCustomFilterChange] Error fetching filter data = ", e);
                this.loading = false;

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            let tempSelectedColumnFields = []; // Use a temporary array to build the list

            const defaultMandatoryColumnField = "codeId129";
            tempSelectedColumnFields.push(defaultMandatoryColumnField);

            this.customFilterComponents.forEach((item) => {
                if (item.code && this.columnConfig.some(config => config.field === item.code) && !tempSelectedColumnFields.includes(item.code)) {
                    tempSelectedColumnFields.push(item.code);
                }
            });

            this.selectedColumns = tempSelectedColumnFields;

            try {
                this.lazyParams.customFilterId = this.selectedCustomFilter;

                if (this.lastActiveTab === 20) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.searchStockDataForCountryAndSpecificCode(
                            this.selectedCountry, 'S', this.searchCriteria.value, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else if (this.lastActiveTab === 22) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.searchStockDataForCountryAndSpecificCode(
                            this.selectedCountry, 'S', this.searchCriteria, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else if (this.lastActiveTab === 21) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.processAdvancedSearchForStockData(
                            this.advancedSearchStockData, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else {
                    await this.loadData();
                }

            } catch (e) {
                console.error("Error applying custom filter or fetching data:", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            } finally {
                this.loading = false;
            }
        },
        async onCompanyCodeClick(inputStockData) {
            this.loading = true;

            console.log("[Overview][onCompanyCodeClick] this.lastActiveTab = ", this.lastActiveTab);
            console.log("[Overview][onCompanyCodeClick] inputStockData = ", inputStockData);

            try {
                this.activeTab = 4;
                // this.lastActiveTab = 4;
                this.selectedFormat = "Extended";
                this.selectedCustomFilter = null;

                this.specificStockData = inputStockData;
                this.specificStockDataArray = [inputStockData];

                try {
                    const [stockHistoryInfo] = await Promise.all([
                        StockHistoryService.getStockHistory(inputStockData.exchangeId073, inputStockData.codeId129)
                    ]);

                    this.stockHistory = stockHistoryInfo.data;
                    this.stockHistory = stockHistoryInfo.data.filter(item => item.year >= 1999);
                } catch (e) {
                    console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                this.onStockDataStockHistoryOptionChange();

                this.chartKey++;
                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onStockDataTimePeriodChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                }

                if (selectedOption) {
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => {
                                    const value = item[selectedOption];
                                    return (typeof value === 'number' && !isNaN(value)) ? value : null;
                                }),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false;
            }

        },
        async onStockDataStockHistoryOptionChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;
                }

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
    }
};
</script>

<style scoped>
.p-multiselect-panel .p-multiselect-items {
    scroll-behavior: auto !important;
}

a {
    text-decoration: none;
}


.highlight {
    background-color: #EEA839;
    color: black;
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }
}
</style>
